import React, { FC, useEffect } from 'react';
import { useEventLogger } from '@/utilities/analyticsHelper';
import { EventNames } from '@/constants';
import Hero from './Hero';

const PageContent: FC = () => {
  const logger = useEventLogger({
    user_flow: 'Direct to Enrollment',
  });

  useEffect(() => {
    logger({
      name: EventNames.SCREEN_VIEWED,
      data: {
        step_name: 'Welcome',
        step_number: '0',
      },
    });
  }, []);

  return <Hero />;
};

export default PageContent;
